import { LodashSortOrderModel } from '../models/lodash-sort-order.model';

export const LodashSortOrder: LodashSortOrderModel = {
  asc: 'asc',
  desc: 'desc'
};